import { STORE } from '../model';

export const getContractUpdateId = (store: STORE): string => store.contracts.updateContractId;
